import React, { useEffect, useRef } from 'react';
import './LegalPage.css';
 
const LegalPage = () => {
  const observerRef = useRef(null);
 
  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observerRef.current?.observe(el));
    return () => observerRef.current?.disconnect();
  }, []);
 
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="section-container">
          <div className="legal-hero-content animate-on-scroll">
            <h1 className="legal-title">
              Mentions <span className="text-gradient">légales</span>
            </h1>
            <p className="legal-subtitle">Conformément à la loi n°2004-575 du 21 juin 2004</p>
          </div>
        </div>
      </section>
 
      <section className="section-padding">
        <div className="section-container">
          <div className="legal-content animate-on-scroll">
 
            <div className="legal-block">
              <h2>1. Éditeur du site</h2>
              <p>Le présent site <strong>synaprocess.fr</strong> est édité par :</p>
              <ul>
                <li><strong>Nom :</strong> Sabrina Baala</li>
                <li><strong>Activité :</strong> Structuration opérationnelle — SYNA</li>
                <li><strong>SIRET :</strong> En cours d'immatriculation</li>
                <li><strong>Adresse :</strong> Paris, France</li>
                <li><strong>Email :</strong> <a href="mailto:contact@synaprocess.fr">contact@synaprocess.fr</a></li>
                <li><strong>Téléphone :</strong> 06 95 34 10 06</li>
              </ul>
            </div>
 
            <div className="legal-block">
              <h2>2. Hébergement</h2>
              <p>Le site est hébergé par :</p>
              <ul>
                <li><strong>Société :</strong> IONOS SE</li>
                <li><strong>Adresse :</strong> 7 Place de la Gare, 57200 Sarreguemines, France</li>
                <li><strong>Site web :</strong> <a href="https://www.ionos.fr" target="_blank" rel="noreferrer">www.ionos.fr</a></li>
              </ul>
            </div>
 
            <div className="legal-block">
              <h2>3. Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes) est la propriété exclusive de SYNA — Sabrina Baala, sauf mention contraire. Toute reproduction, distribution ou utilisation sans autorisation préalable est strictement interdite.
              </p>
            </div>
 
            <div className="legal-block">
              <h2>4. Responsabilité</h2>
              <p>
                SYNA s'efforce de maintenir les informations de ce site à jour et exactes. Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations diffusées. L'utilisation des informations de ce site se fait sous la seule responsabilité de l'utilisateur.
              </p>
            </div>
 
            <div className="legal-block">
              <h2>5. Liens hypertextes</h2>
              <p>
                Le site synaprocess.fr peut contenir des liens vers des sites tiers. SYNA n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
              </p>
            </div>
 
            <div className="legal-block">
              <h2>6. Droit applicable</h2>
              <p>
                Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </div>
 
          </div>
        </div>
      </section>
    </div>
  );
};
 
export default LegalPage;